import DialogWrapper from "./DialogWrappr";

export default DialogWrapper;
